import { hyphenateSync as hyphenateEn } from 'hyphen/en';
import { hyphenateSync as hyphenateFi } from 'hyphen/fi';
import getCurrentTrimmedLocale from './getCurrentTrimmedLocale';

/**
 *
 * @param text - String text to hyphenate
 * @param minWordLength - minimum word length before hyphenating
 * @returns hyphenated string
 */
export const hyphenate = (text, minWordLength) => {
  if (text) {
    const locale = getCurrentTrimmedLocale();
    const min = minWordLength ?? 0;

    switch (locale) {
      case 'en':
        return hyphenateEn(text, { minWordLength: min });
      case 'fi':
        return hyphenateFi(text, { minWordLength: min });
      default:
        return text;
    }
  } else {
    return '';
  }
};
